module.exports = __webpack_public_path__ + "img/khtn_icon.9de35d9c.svg";